import React, { useState, useEffect } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";


const SightSeeingBookingDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { user, loading: userLoading } = useAuth();

  const [pageLoading, setPageLoading] = useState(true);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [productDetails, setProductDetails] = useState(null);
  const [travellers, setTravellers] = useState([]);

  useEffect(() => {
    const getData = () => {
      apiService
        .getById(config.GETSIGHTSEEINGBOOKINGDETAILS, params.sightSeeingBookingId)
        .then((res) => { 
         
            setBookingDetails(res); 
           setTravellers(res.travellerInfos || []);
        })
        .catch((err) => {
          console.error("Error fetching sightseeing data", err);
        })
        .finally(() => {
          setPageLoading(false); 
        });
    };

    if (user) {
      getData();
    }
  }, [user, params.sightSeeingBookingId]);

  if (userLoading) {
    return (
      <div className="text-center p-5">
        <p>Loading ...</p>
      </div>
    );
  }

  if (!user) {
    navigate("/");
    return null;
  }

  return (
    <div id="layout-wrapper">
 <Header User={user} activeSection="sightseeing" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid invoice-container">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                
                </div>
                <div className="card-body">
                  {pageLoading ? (
                    <div className="text-center">
                      <img
                        src="/assets/images/loader.webp"
                        width="64px"
                        height="64px"
                        alt="Loading..."
                      />
                      <p>Loading, Please wait...</p>
                    </div>
                  ) : bookingDetails ? (
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="bg-white shadow-md rounded p-3 p-sm-4 mb-4">
                          <h4 className="text-6">Sightseeing Booking Details</h4>
                        </div>
                        <div className="card mb-4" style={{ textAlign: "start" }}>
                          <div className="card-body">
                            <div className="row mb-3">
                              <div className="col-lg-3 mb-3">
                                <label><b>Booking No</b>: {bookingDetails.bookingNo}</label>
                              </div>
                              <div className="col-lg-3 mb-3">
                                <label><b>Supplier Booking ID</b>: {bookingDetails.supplierBookingId}</label>
                              </div>
                              <div className="col-lg-3 mb-3">
                                <label><b>Destination</b>: {bookingDetails.city}</label>
                              </div>
                              <div className="col-lg-3">
                                <label><b>Travel Date</b>: {moment(bookingDetails.travelDate).format("Do MMM YYYY")}</label>
                              </div>
                            </div>
                            {productDetails && (
                              <div className="row mb-3">
                                <div className="col-lg-6">
                                  <label><b>Tour Name</b>: {productDetails.productName}</label>
                                </div>
                              </div>
                            )}
                            <div className="row mb-3">
                              <div className="col-lg-3">
                                <label><b>Booking Status</b>: <span className={`badge bg-${bookingDetails.bookingStatus === 'CONFIRMED' ? 'success' : 'warning'}`}>{bookingDetails.bookingStatus}</span></label>
                              </div>
                              <div className="col-lg-3">
                                <label><b>Payment Status</b>: <span className={`badge bg-${bookingDetails.paymentStatus === 'SUCCESS' ? 'success' : 'danger'}`}>{bookingDetails.paymentStatus}</span></label>
                              </div>
                              <div className="col-lg-3">
                                <label><b>Adults</b>: {bookingDetails.noOfAdults}</label>
                              </div>
                              <div className="col-lg-3">
                                <label><b>Kids</b>: {bookingDetails.noOfKids}</label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-3">
                                <label><b>Total Price</b>: {Math.round(bookingDetails.customerPrice)} INR</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header">
                            <h5>Travellers</h5>
                          </div>
                          <div className="card-body">
                            <div className="table-responsive table-card">
                              <table className="table align-middle">
                                <thead className="table-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Type</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {travellers.length > 0 ? (
                                    travellers.map((traveller, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{`${traveller.title}. ${traveller.firstName} ${traveller.lastName}`}</td>
                                        <td>{traveller.travelerType}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="3" className="text-center">No traveller information available.</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center">
                      <h4>Booking Not Found</h4>
                      <p>We could not find the details for this booking.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SightSeeingBookingDetails;